export default "__VITE_ASSET__D6vA5LHp__"